// Imports
import { getStorage, setStorage, deleteStorage, clearStorage } from './storage.js';
import { isDevelopment, sendXHR, getVarType } from './utils.js';


//
// Namespace
//

export var gu_auth = {
    'var': {
        'oAuthToken': null,
        'oAuthImpersonationToken': null,
        'global_error': '',
        'store_id': 'gua-',
        'logoutURL': ''
    },
    'fn': {},
    'AppConfig': {},
    'base_urls': {},
    'system_messages': {},
    'callback': function(){},
    'errorCallback': function(){}
};


//
// Utilities
//

// Set up gu_auth object
gu_auth.fn.configureSettings = function(config, callback_fn, error_callback_fn) {
    gu_auth['AppConfig'] = config['portal_configuration']['AppConfig'];
    gu_auth['base_urls'] = config['base_urls'];
    gu_auth['system_messages'] = config['system_messages'];
    gu_auth['callback'] = callback_fn;
    gu_auth['errorCallback'] = error_callback_fn;
    gu_auth['var']['logoutURL'] = config['portal_links']['logout']['url'];
};

// Set up simulation extension
gu_auth.fn.configureSimulationSettings = function(callbacks) {
    gu_auth['simulation'] = {
        'callbacks': callbacks
    };
};

// Handle object management in browser storage
gu_auth.fn.handleStorageObject = function(method, storage_type, storage_key, set_data) {
    var item_key = storage_key;

    if(storage_type !== 'cookie') {
        item_key = gu_auth['var']['store_id'] + storage_key;
    }

    switch(method) {
        case 'GET':
            return getStorage(storage_type, item_key);
        case 'SET':
            setStorage(storage_type, item_key, JSON.stringify(set_data));
            break;
        case 'REMOVE':
            deleteStorage(storage_type, item_key, set_data);
            break;
        case 'CLEAR':
            clearStorage(storage_type);
            break;
    }
};

// Clear token on logout
gu_auth.fn.logout = function() {
    var token_name = gu_auth['AppConfig']['ssoTokenName'];
    var cookie_domain = '.griffith.edu.au';

    // Delete the SSO cookie
    gu_auth.fn.handleStorageObject('REMOVE', 'cookie', token_name, cookie_domain);

    function delete_cookie(name, path, domain) {
        try {
            document.cookie = name + "=" +
            (path ? ";path=" + path : "") +
            (domain ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        } catch (ignore) { }
    }
    function expireAllcookies() {
        var cookie_container = document.querySelector('#cookies');
        var cookie_whitelist = cookie_container.getAttribute('data-whitelist').split('; ');
        
        try {
            var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/),
                nLen = aKeys.length,
                nIdx = 0;
            while (nIdx < nLen) {
                aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
                if (aKeys[nIdx]) {
                    if (cookie_whitelist.indexOf(aKeys[nIdx]) === -1) {
                        delete_cookie(aKeys[nIdx], "/", ".griffith.edu.au");
                        delete_cookie(aKeys[nIdx], "/", "staging-auth.griffith.edu.au");
                        delete_cookie(aKeys[nIdx], "/", "test-auth.griffith.edu.au")
                        delete_cookie(aKeys[nIdx], "/", "auth.griffith.edu.au");
                    }
                }
                nIdx = nIdx+1;
            }
        } catch (ignore) { }
    }

    expireAllcookies();
    

    // Clear session storage
    gu_auth.fn.handleStorageObject('CLEAR', 'session');
};


//
// Token Configuration
//

// Create token based on API response
gu_auth.fn.createToken = function(oauth_token) {
    var token_config = {
        'token': oauth_token['access_token'],
        'expiresSeconds': oauth_token['expires_in']
    };

    // Set a final expiry time
    token_config['expiresAbsolute'] = new Date(Date.now() + 1000 * token_config['expiresSeconds']);

    return token_config;
};

// Set up timer intervals for the token
gu_auth.fn.setTokenTimers = function(gu_token) {
    // Start the countdown timer
    gu_token['timer'] = setInterval(function(){
        gu_token['expiresSeconds'] = gu_auth.fn.updateExpiry(gu_token);

        // if expired, terminate the timer
        if (gu_token['expiresSeconds'] === 0) {
            gu_auth.fn.terminateTimer(gu_token);

            // Log out
            gu_auth.fn.logout();

            // Redirect to logout page
            window.location = gu_auth['var']['logoutURL'];
        }
    }, 1000);

    return gu_token;
};

// Set up common functions to create token
gu_auth.fn.setTokenSkeleton = function(token_data) {
    var json_data = JSON.parse(token_data);

    var gu_token = gu_auth.fn.createToken(json_data);
    gu_token = gu_auth.fn.setTokenTimers(gu_token);

    return gu_token;
};

// Recompute expiry
gu_auth.fn.updateExpiry = function(gu_token) {
    var expires_seconds = gu_token['expiresSeconds'];

    if (expires_seconds > 0) {
        // we can not rely on the timer interval being accurate, it may be suspended by
        // the browser if the page goes to the background for instance.
        // Therefore we will recompute from the absolute expiry date each time.
        expires_seconds = Math.floor((gu_token['expiresAbsolute'].getTime() - Date.now()) / 1000);

        // Stop at zero.
        if (expires_seconds <= 0) {
            expires_seconds = 0;
        }
    }

    return expires_seconds;
};

// Terminate timer
gu_auth.fn.terminateTimer = function(gu_token) {
    if (gu_token['timer']) {
        // Cancel the interval
        clearInterval(gu_token['timer']);

        // Delete the reference
        delete gu_token['timer'];
    }
};


//
// Token Helpers
//

// Get the token by name
gu_auth.fn.getToken = function(token_name) {
    return gu_auth['var'][token_name];
};

// Set the token by name
gu_auth.fn.setToken = function(token_name, token) {
    gu_auth['var'][token_name] = token;
};

// Handle clearing of a token
gu_auth.fn.clearToken = function(token_name) {
    var gu_token = gu_auth.fn.getToken(token_name);
    
    if(gu_token !== null) {
        gu_auth.fn.terminateTimer(gu_token);

        if(token_name === 'oAuthToken') {
            // Log out
            gu_auth.fn.logout();

            // Redirect to logout page
            window.location = gu_auth['var']['logoutURL'];
        }

        if(token_name === 'oAuthImpersonationToken') {
            gu_auth.fn.setToken('oAuthImpersonationToken', null);
        }
    }
};

// Get user token
gu_auth.fn.getUserToken = function() {
    return gu_auth.fn.getToken('oAuthToken');
};

// Sign out of session
gu_auth.fn.clearUserToken = function() {
    gu_auth.fn.clearToken('oAuthToken');
};

// Get simulation token
gu_auth.fn.getSimulationToken = function() {
    return gu_auth.fn.getToken('oAuthImpersonationToken');
};

// Stop user simulation
gu_auth.fn.clearSimulationToken = function() {
    gu_auth.fn.clearToken('oAuthImpersonationToken');
};

// Completely sign out of session
gu_auth.fn.clearAllAuthTokens = function() {
    gu_auth.fn.clearUserToken();
    gu_auth.fn.clearSimulationToken();
};

// Get active token
gu_auth.fn.getActiveToken = function(request_type) {
    var user_token = gu_auth.fn.getUserToken();
    var simulation_token = gu_auth.fn.getSimulationToken();
    var active_token = null;

    if(request_type === 'simulation') {
        // Always use the user token when attempting simulation
        active_token = 'Bearer ' + user_token['token'];
    } else {
        if(simulation_token !== null) {
            active_token = 'Bearer ' + simulation_token['token'];
        } else if(user_token !== null) {
            active_token = 'Bearer ' + user_token['token'];
        }
    }

    return active_token;
};

// Get token from storage
gu_auth.fn.getBrowserToken = function() {
    return getStorage('cookie', gu_auth['AppConfig']['ssoTokenName']);
};


//
// HTTP Requests
//

// Set up configuration for user token
gu_auth.fn.requestUserToken = function(browser_token) {
    // Clear any existing auth
    gu_auth.fn.clearAllAuthTokens();

    var request_extras = 'client_id=' + gu_auth['AppConfig']['apiClientId'];
    request_extras += '&grant_type=urn:gu:oauth:grant-type:sso';
    request_extras += '&assertion=' + browser_token;

    gu_auth.fn.requestToken('standard', request_extras, gu_auth.fn.setUserToken, gu_auth.fn.userTokenFailure);
};

// Set up configuration for simulation token
gu_auth.fn.requestSimulationToken = function(s_number, failureCallback) {
    // Clear any existing simulation auth
    gu_auth.fn.clearSimulationToken();

    var request_extras = 'client_id=' + gu_auth['AppConfig']['apiClientId'];
    request_extras += '&grant_type=urn:gu:oauth:grant-type:impersonate';
    request_extras += '&user=' + s_number;

    gu_auth.fn.requestToken('simulation', request_extras, gu_auth.fn.setSimulationToken, failureCallback);
};

// Send a request to the /token endpoint on the api and handle the returned error or token data
gu_auth.fn.requestToken = function(request_type, request_extras, request_success, request_failure) {
    var xhr_parameters = {
        'request_url': gu_auth['AppConfig']['apiRoot'] + 'token',
        'request_extras': request_extras,
        'request_success': request_success,
        'request_failure': request_failure
    };

    // This is an authenticated request
    var gu_token = gu_auth.fn.getActiveToken(request_type);

    sendXHR(xhr_parameters, 'FORM_POST', gu_token);
};


/*
    Log in flow
*/

// Check for a SSO session
gu_auth.fn.checkSSO = function() {
    var browser_token = gu_auth.fn.getBrowserToken();
    var login_count = gu_auth.fn.getLoginCount();

    if(login_count === 1) {
        gu_auth.fn.logout();
        gu_auth.fn.incrementLoginCount();

        browser_token = '';
    }

    if(browser_token === '') {
        // No token - save landing page
        gu_auth.fn.saveLocation();

        // Save the type of visitor
        gu_auth.fn.saveVisitorType('fresh');

        // Request token
        gu_auth.fn.startSSO();
    } else {
        // Token exists - navigate to saved landing page
        gu_auth.fn.switchLocation();

        // Save the type of visitor
        gu_auth.fn.saveVisitorType('return');

        // Request new token
        gu_auth.fn.requestUserToken(browser_token);
    }
};

// Save the type of visitor you are
gu_auth.fn.saveVisitorType = function(visitor_type) {
    gu_auth.fn.handleStorageObject('SET', 'session', 'visitor-type', visitor_type);
};

// Save the page you're trying to access to storage
gu_auth.fn.saveLocation = function() {
    var landing_page = window.location.hash;

    gu_auth.fn.handleStorageObject('SET', 'session', 'landing-page', landing_page);
};

// Switch to the page you're trying to access from storage
gu_auth.fn.switchLocation = function() {
    var landing_page = gu_auth.fn.handleStorageObject('GET', 'session', 'landing-page', '');
    var visitor_type = gu_auth.fn.handleStorageObject('GET', 'session', 'visitor-type', '');
    var iframe_switch = gu_auth.fn.handleStorageObject('GET', 'session', 'switch', '');
    var switch_location = false;

    // Parse data
    visitor_type = JSON.parse(visitor_type);
    iframe_switch = JSON.parse(iframe_switch);

    // Switch if you're a fresh visitor
    if(visitor_type === 'fresh') {
        switch_location = true;
    }

    // Check for a PeopleSoft cookie
    if(iframe_switch !== null) {
        switch_location = true;
    }

    // Remove the iFrame flag
    gu_auth.fn.removeIframeFlag();

    if(landing_page !== null && switch_location) {
        // Convert back to string
        landing_page = JSON.parse(landing_page);
        
        // Remove saved landing page
        gu_auth.fn.removeLocation();

        // Update hash
        window.location.hash = landing_page;
    }
};

// Remove the page you're trying to access from storage
gu_auth.fn.removeLocation = function() {
    gu_auth.fn.handleStorageObject('REMOVE', 'session', 'landing-page', '');
};

// Remove the iFrame switch from storage
gu_auth.fn.removeIframeFlag = function() {
    gu_auth.fn.handleStorageObject('REMOVE', 'session', 'switch', '');
};

// Initiate SSO process
gu_auth.fn.startSSO = function() {
    var login_page = gu_auth['AppConfig']['ssoAuthoriseFlowUrl'];
    var return_page = window.location.href;
    var replace_string = gu_auth['AppConfig']['ssoAuthoriseFlowUrlReplaceReturnUrl'];

    login_page = login_page.replace(replace_string, return_page);

    window.location.replace(login_page);
};

// Error handler for user token failure
gu_auth.fn.userTokenFailure = function(response) {
    console.log('Error with the user token');
    console.log(response);

    var no_system_errors = true;
    var system_message = '';

    // Check for error messages
    if(response) {
        if (typeof(response) !== "undefined"){
            if(typeof(response['status']) !== 'undefined') {
                if(response['status'] === 0) {
                    no_system_errors = false;

                    if (typeof(gu_auth['system_messages']) !== "undefined"){
                        if (typeof(gu_auth['system_messages']['timeout']) !== "undefined"){
                            system_message = gu_auth['system_messages']['timeout']['network'];

                            // Save message globally
                            gu_auth.errorCallback(system_message);
                        }
                    }
                }
            }
            if (typeof(response['error']) !== "undefined"){
                if (response['error'] == "invalid_grant"){
                    no_system_errors = false;

                    // console.log('failed to log in - error with grant');
                    if (typeof(gu_auth['system_messages']) !== "undefined"){
                        if (typeof(gu_auth['system_messages']['authfail']) !== "undefined"){
                            system_message = gu_auth['system_messages']['authfail']['generic'];

                            // Save message globally
                            gu_auth.errorCallback(system_message);
                        }
                    }
                }
            }
        }
    }

    // No errors, try logging in with new token
    if(no_system_errors) {
        var can_log_in = gu_auth.fn.canLogIn();

        if(can_log_in) {
            gu_auth.fn.incrementLoginCount();
            gu_auth.fn.startSSO();
        } else {
            console.log('There was an error logging in - gatekeeper may be down.');
            system_message = gu_auth['system_messages']['authfail']['generic'];

            // Save message globally
            gu_auth.errorCallback(system_message);
            
            gu_auth.fn.handleStorageObject('REMOVE', 'session', 'login-count', '');
        }
    }
};

// Error handler for simulation token failure
gu_auth.fn.simulationTokenFailure = function(response) {
    console.log('Error with simulation token');
    console.log(response);
};

// Get login attempts
gu_auth.fn.getLoginCount = function() {
    var login_count = gu_auth.fn.handleStorageObject('GET', 'session', 'login-count', '');

    if(login_count) {
        return parseInt(login_count);
    } else {
        return 1;
    }
};

// Increment login attempts
gu_auth.fn.incrementLoginCount = function() {
    var login_count = gu_auth.fn.getLoginCount();
    login_count = parseInt(login_count) + 1;

    gu_auth.fn.setLoginCount(login_count);
};

// Count login attempts
gu_auth.fn.setLoginCount = function(login_count) {
    gu_auth.fn.handleStorageObject('SET', 'session', 'login-count', login_count);
};

// Check login count threshold
gu_auth.fn.canLogIn = function() {
    var login_max = gu_auth['AppConfig']['loginAttempts'];
    var login_count = gu_auth.fn.handleStorageObject('GET', 'session', 'login-count', '');

    if(login_count) {
        login_count = parseInt(login_count);

        if (login_count >= login_max){
            return false;
        } else {
            return true;
        }
    } else {
        return true;
    }
};


//
// Helpers
//

gu_auth.fn.setUserToken = function(response) {
    var gu_token = gu_auth.fn.setTokenSkeleton(response);
    gu_auth.fn.setToken('oAuthToken', gu_token);

    gu_auth.fn.checkForSimulation();
};

// Check if user was already simulating
gu_auth.fn.checkForSimulation = function() {
    var user_personalisation = squiz.fn.getStorage('userpersonalisation', 'session', 'json');
    var is_simulating = false;

    if (user_personalisation && user_personalisation['data']) {
        var s_number = user_personalisation['data']['sNumber'];
        var is_impersonated = user_personalisation['data']['isImpersonated'];
        if (is_impersonated === true) {
            is_simulating = true;
        }
    }

    if (is_simulating) {
        gu_auth.fn.requestSimulationToken(s_number, gu_auth.fn.simulationTokenFailure);
    } else {
        gu_auth.callback();
    }
    
};

gu_auth.fn.setSimulationToken = function(response) {
    var gu_token = gu_auth.fn.setTokenSkeleton(response);
    gu_auth.fn.setToken('oAuthImpersonationToken', gu_token);

    // Continue processing
    var force_refresh = true;
    
    gu_auth['simulation']['callbacks'].set(force_refresh);
};

gu_auth.fn.makeAbsoluteUrl = function(relative_url) {
    return gu_auth['AppConfig']['apiRoot'] + gu_auth['AppConfig']['apiPath'] + relative_url;
};


//
// User Roles
//

// Check for staff and student combination
gu_auth.fn.isStaffAndStudent = function(attribute_list) {
    var user_role = attribute_list['ROLE'];
    var role_type = getVarType(user_role);
    var is_staff = false;
    var is_student = false;
    
    switch(role_type) {
        case 'array':
            for (var index = 0; index < user_role.length; index++) {
                if(user_role[index] === 'STAFF') {
                    is_staff = true;
                }

                if(user_role[index] === 'STUDENT') {
                    is_student = true;
                }
            }
            
            break;
        default:
            return false;
    }

    if(is_staff && is_student) {
        return true;
    }

    return false;
};

// Check for staff mode view
gu_auth.fn.canAccessStaffMode = function(attribute_list) {
    var user_role = attribute_list['ROLE'];
    var role_type = getVarType(user_role);
    var valid_roles = ['PORTAL_SUPPORT', 'STAFF'];
    
    switch(role_type) {
        case 'string':
            if(valid_roles.indexOf(user_role) !== -1) {
                return true;
            }

            return false;
        case 'array':
            for (var index = 0; index < user_role.length; index++) {
                if(valid_roles.indexOf(user_role[index]) !== -1) {
                    return true;
                }
            }

            return false;
        default:
            return false;
    }
};

// Check for simulation access
gu_auth.fn.canSimulate = function(user_profile) {
    var user_can_simulate = user_profile['canImpersonate'];
    var user_is_simulated = user_profile['isImpersonated'];
    var user_role = user_profile['attributes']['ROLE'];
    var role_type = getVarType(user_role);
    var valid_roles = ['PORTAL_SUPPORT', 'SUPPORT_STAFF', 'PEARSON_SUPPORT'];

    // Check profile
    if(user_can_simulate) {
        return true;
    }

    if(user_is_simulated) {
        return true;
    }

    // Check roles    
    switch(role_type) {
        case 'string':
            if(valid_roles.indexOf(user_role) !== -1) {
                return true;
            }

            return false;
        case 'array':
            for (var index = 0; index < user_role.length; index++) {
                if(valid_roles.indexOf(user_role[index]) !== -1) {
                    return true;
                }
            }

            return false;
    }

    return false;
};

// Check for access to modify attributes
gu_auth.fn.canModifyAttributes = function(user_profile) {
    var user_can_modify = user_profile['canTestPersonalisation'];
    var user_is_simulated = user_profile['isImpersonated'];
    var user_role = user_profile['attributes']['ROLE'];
    var role_type = getVarType(user_role);
    var valid_roles = ['PORTAL_SUPPORT', 'PEARSON_SUPPORT'];
    var invalid_roles = ['SUPPORT_STAFF'];
    var can_modify = false;

    // Check profile
    if(user_can_modify) {
        can_modify = true;
    }

    if (user_is_simulated) {
        return true;
    }

    // Check roles
    switch(role_type) {
        case 'string':
            if(invalid_roles.indexOf(user_role) !== -1) {
                can_modify = false;
            }

            if(valid_roles.indexOf(user_role) !== -1) {
                can_modify = true;
            }

            break;
        case 'array':
            can_modify = false;
            for (var index = 0; index < user_role.length; index++) {
                if(valid_roles.indexOf(user_role[index]) !== -1) {
                    can_modify = true;
                }
            }
            
            break;
    }

    return can_modify;
};